import { Component } from '@angular/core';

@Component({
  selector: 'bhub-cell-content-editor',
  standalone: false,
  templateUrl: './cell-content-editor.component.html',
  styles: ``
})
export class CellContentEditorComponent {

}
